import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { useFloatingSelect } from '../../../hooks'
import { stopPropagation } from '../../../utils/events'
import Button from '../../Button'
import { FloatingSelectDropdown } from '../../Floating'
import { ListItem } from '../../ListItem'

import { SORTING_BUTTON_ICON_HEIGHT } from './TableHeaderRowCellSortingButton.constants'
import {
  getButtonQaName,
  getSortingDirection,
} from './TableHeaderRowCellSortingButton.utils'

import * as styles from './TableHeaderRowCellSortingButton.module.css'

function TableHeaderRowCellSortingButton(props) {
  const {
    afterIconHeight = SORTING_BUTTON_ICON_HEIGHT,
    className = styles.TableHeaderRowCellSortingButton,
    disabled,
    isHovered,
    isLoading,
    options,
    ordering,
    orderingField,
    tooltip = 'Table.SortingTooltipKey',
    tooltipPlacement = FLOATING_ELEMENT_PLACEMENT.top,
    ...restProps
  } = props

  const { t } = useTranslation()

  const { context, floatingStyles, getFloatingProps, isOpen, refs, setOpen } =
    useFloatingSelect({ placement: FLOATING_ELEMENT_PLACEMENT.bottomStart })

  const { setReference } = refs

  const { Icon, sortDirection } =
    ordering && orderingField
      ? getSortingDirection(ordering, orderingField)
      : {}

  function handleClick(event) {
    stopPropagation(event)

    setOpen(isOpen => !isOpen)
  }

  function getHandleClickOption(option) {
    return () => {
      setOpen(false)

      props.onClick?.(orderingField, option.value)
    }
  }

  const buttonClassName = classNames(className, {
    [styles.disabled]: disabled,
  })

  const qaNameButton = props.qaName || getButtonQaName(orderingField)

  return (
    <>
      <div className={styles.buttonContainer} ref={setReference}>
        <Button.Text
          {...restProps}
          isGrey
          afterIconProps={
            isHovered || sortDirection || isOpen
              ? { Icon, height: afterIconHeight }
              : null
          }
          className={buttonClassName}
          disabled={isLoading}
          qaName={qaNameButton}
          tooltip={t(tooltip)}
          tooltipPlacement={tooltipPlacement}
          onClick={handleClick}
        />
      </div>
      <FloatingSelectDropdown
        context={context}
        floatingStyles={floatingStyles}
        getFloatingProps={getFloatingProps}
        isOpen={isOpen}
        refs={refs}
      >
        <div className={styles.list} onClick={stopPropagation}>
          {options.map(option => (
            <ListItem
              isActive={sortDirection && option.value === sortDirection}
              key={option.id}
              qaName={option.value}
              text={t(option.text)}
              textClassName={styles.listItemText}
              onClick={getHandleClickOption(option)}
            />
          ))}
        </div>
      </FloatingSelectDropdown>
    </>
  )
}

export default TableHeaderRowCellSortingButton
